import gql from "graphql-tag";

export const PIZZA_DAY_COLLECTION = "pizza";

export const getPizzaDayProductPath = (slug: string) =>
  `/catalog/${PIZZA_DAY_COLLECTION}/${slug}`;

export const GET_PIZZA_DAY = gql`
  query pizzaDay {
    shop {
      id
      pizzaDay {
        discountName
        productSlug
      }
    }
  }
`;
